import { AfterViewInit, Directive, EventEmitter, Output } from '@angular/core';

@Directive({
  selector: '[appLifecycleHooksHandler]',
  standalone: true,
})
export class LifecycleHooksHandlerDirective implements AfterViewInit {
  @Output() emitAfterViewInit = new EventEmitter<void>();

  ngAfterViewInit(): void {
    this.emitAfterViewInit.emit();
  }
}
